import Axios from "axios";
import fileDownload from "js-file-download";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  fetchRoadXmlFilesFailure, fetchRoadXmlFilesSuccess, downloadRoadXmlFilesFailure, downloadRoadXmlFilesSuccess
} from "../actions/xmlFile.action";
import * as selectors from './selector';


//worker functions
function* workerFetchRoadXmlFiles(action) {
  try {
    const moment = require('moment');
    const access_token = yield select(selectors.access_token);

    const resp = yield call(
      Axios.get, `${process.env.REACT_APP_BASE_URL}/ivrapi` + `${process.env.REACT_APP_ROADS_XML_FILE_PATH}`, {
      headers: {
        Authorization: 'Bearer ' + access_token,
        transactionId: 'CCCRC.' + moment().unix(),
        requestTimeStamp: moment.utc().toJSON(),
      }
    });

    yield put(fetchRoadXmlFilesSuccess(resp.data));
  } catch (e) {
    yield put(fetchRoadXmlFilesFailure(e.message));
  }
}

function* workerDownloadRoadXmlFiles(action) {
  try {
    const moment = require('moment');
    const access_token = yield select(selectors.access_token);
    const resp = yield call(
      Axios.get, `${process.env.REACT_APP_BASE_URL}/ivrapi` + `${process.env.REACT_APP_ROADS_XML_DOWNLOAD_FILE_PATH}` + action.payload.roadXmlFiles,
      {
        headers: {
          Authorization: 'Bearer ' + access_token,
          transactionId: 'RCE.SRC.' + moment().unix(),
          requestTimeStamp: moment.utc().toJSON(),
          //accessKeyaccessKey: 'abf683eaa28e4e68a350413d25bd81e4'
        }
      });
    if (action.payload.actionType === 'openInNewTab') {
      var blobData = [resp.data]
      var blob = new Blob(blobData, { type: 'application/xml' });
      var blobURL = (window.URL && window.URL.createObjectURL) ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
      window.open(blobURL, '_blank');

    }
    else {
      fileDownload(resp.data, action.payload.fileName);
    }
    yield put(downloadRoadXmlFilesSuccess(resp.data));
  } catch (e) {
    yield put(downloadRoadXmlFilesFailure(e.message));
  }
}
//Watcher functions
export function* watchDownloadRoadXmlFiles() {
  yield takeLatest("DOWNLOAD_ROAD_XML_FILES_START", workerDownloadRoadXmlFiles);
}
export function* watchFetchRoadXmlFiles() {
  yield takeLatest("FETCH_ROAD_XML_FILES_START", workerFetchRoadXmlFiles);
}
